// 모집요항(募集要項) 체크리스트 — 로그인 불필요, 로컬 저장
export const checklistMeta = {
  title: '요강 체크리스트',
  lede:
    '대학 모집요항 PDF를 열어 두고, 항목마다 확인 여부를 표시하세요. 로그인 없이 이 기기에만 저장됩니다. 최종 근거는 항상 해당 연도 원문입니다.',
  updatedAt: '2026-07',
};

export const checklistSections = [
  {
    id: 'file',
    title: '파일·전형 확인',
    items: [
      {
        id: 'file-year',
        label: '표지·파일명에 지원 연도(令和○ / 20XX)가 맞는지 확인했다',
      },
      {
        id: 'file-track',
        label: '유학생 특별 / 일반선발 등, 내가 지원할 전형의 PDF를 열었다',
      },
      {
        id: 'file-faculty',
        label: '학부·학과(전공) 명칭이 지망과 일치하는지 확인했다',
      },
    ],
  },
  {
    id: 'eligibility',
    title: '출원자격 (出願資格)',
    items: [
      {
        id: 'elig-12y',
        label: '12년 교육과정·졸업(예정) 등 학력 요건을 확인했다',
      },
      {
        id: 'elig-nationality',
        label: '국적·재류자격(유학 등) 관련 제한 문구를 확인했다',
      },
      {
        id: 'elig-age',
        label: '연령·기타 특별 자격 조건이 있으면 기록했다',
      },
    ],
  },
  {
    id: 'exams',
    title: '시험·성적',
    items: [
      {
        id: 'exam-eju-subjects',
        label: 'EJU 과목·수학 코스·이과 조합을 요강에 맞춰 적었다',
      },
      {
        id: 'exam-eju-session',
        label: 'EJU 인정 회차(6월/11월 등 지정)를 확인했다',
      },
      {
        id: 'exam-eju-lang',
        label: '출제 언어(일본어/영어) 선택 가능 여부를 확인했다',
      },
      {
        id: 'exam-jlpt',
        label: '일본어: EJU 일본어 / JLPT 등 지정 기준을 확인했다',
      },
      {
        id: 'exam-english',
        label: '영어 외부시험(종류·최저·유효기간·직송 여부)을 확인했다',
      },
      {
        id: 'exam-univ',
        label: '대학별 시험(소논문·면접·학력시험) 유무·일정을 확인했다',
      },
    ],
  },
  {
    id: 'schedule',
    title: '일정·비용',
    items: [
      {
        id: 'sch-apply',
        label: '원서 접수 기간·必着(필착) 여부를 캘린더에 넣었다',
      },
      {
        id: 'sch-exam',
        label: '시험일·면접일·합격 발표일을 기록했다',
      },
      {
        id: 'sch-fee',
        label: '검정료(検定料) 금액·납부 방법을 확인했다',
      },
      {
        id: 'sch-enroll',
        label: '입학 수속·입학금 관련 마감을 확인했다',
      },
    ],
  },
  {
    id: 'docs',
    title: '서류·제출',
    items: [
      {
        id: 'doc-list',
        label: '제출 서류 목록(성적·졸업·사진·추천 등)을 체크했다',
      },
      {
        id: 'doc-format',
        label: '번역·공증·원본/사본·온라인 업로드 형식을 확인했다',
      },
      {
        id: 'doc-visa',
        label: '합격 후 비자·입학 안내가 요강 밖 별도 페이지인지 확인했다',
      },
    ],
  },
  {
    id: 'overseas',
    title: '해외출원 (한국에서 지원)',
    mode: 'overseas',
    items: [
      {
        id: 'ov-allowed',
        label: '해외(국외) 거주지 출원이 가능한 전형인지 요강에 확인했다',
      },
      {
        id: 'ov-address',
        label: '제출처 주소·부서명·必着 기준(도착일)을 적었다',
      },
      {
        id: 'ov-mail',
        label: '국제우편·추적 가능 발송 여유 일수를 잡았다',
      },
      {
        id: 'ov-fee',
        label: '검정료 해외 납부(카드·송금·대리) 방법을 확인했다',
      },
      {
        id: 'ov-online',
        label: 'Web 출원·마이페이지·계정 생성 절차를 확인했다',
      },
      {
        id: 'ov-interview',
        label: '화상 면접·온라인 시험 유무와 시차(한국/일본)를 확인했다',
      },
      {
        id: 'ov-docs',
        label: '해외에서 발급하는 증명·번역·공증 일정을 역산했다',
      },
      {
        id: 'ov-visa',
        label: '합격 후 COE·비자 절차가 대학 대행인지 본인 준비인지 확인했다',
      },
    ],
  },
];

export function sectionsForMode(includeOverseas) {
  return checklistSections.filter(
    (s) => s.mode !== 'overseas' || includeOverseas
  );
}

export function flatChecklistItems(includeOverseas = true) {
  return sectionsForMode(includeOverseas).flatMap((section) =>
    section.items.map((item) => ({
      ...item,
      sectionId: section.id,
      sectionTitle: section.title,
    }))
  );
}

export function buildChecklistPlainText(checkedIds, includeOverseas = true) {
  const lines = ['[미라이쥬쿠 요강 체크리스트]', ''];
  if (includeOverseas) lines.push('(해외출원 항목 포함)', '');
  for (const section of sectionsForMode(includeOverseas)) {
    lines.push(`## ${section.title}`);
    for (const item of section.items) {
      const mark = checkedIds.has(item.id) ? '[x]' : '[ ]';
      lines.push(`${mark} ${item.label}`);
    }
    lines.push('');
  }
  lines.push('※ 최종 근거는 해당 연도 대학 모집요항 원문입니다.');
  return lines.join('\n');
}
